// config.pompeufabra.js
  /*
  Institut Pompeu Fabra
  Martotell
  (Jordi Parés)


  especials:

 dades personals:
  adreça desglossada
  observacions necessitats especials

  "progenitor1PM": progenitor1PM, 
  "progenitor1Adreca": progenitor1Adreca, 
  "progenitor1Municipi": progenitor1Municipi, 
  "progenitor1CodiPostal": progenitor1CodiPostal, 
  "progenitor1Provincia": progenitor1Provincia, 
  "progenitor1Pais": progenitor1Pais,

  "progenitor2PM": progenitor2PM, 
  "progenitor2Adreca": progenitor2Adreca, 
  "progenitor2Municipi": progenitor2Municipi, 
  "progenitor2CodiPostal": progenitor2CodiPostal, 
  "progenitor2Provincia": progenitor2Provincia, 
  "progenitor2Pais": progenitor2Pais,



 dades mediques:
  autoritzacio educacio fisica
  contacte emegencia a dades mediques  x2
  llibre vacunacions
  allergia

  quotes
   ordre

  ESO
      1r curs
      2n curs
      3r curs
      4t curs

  Batxillerat
      Batxillerat Artístic
      Batxillerat d'Humanitats i Ciències Socials
      Batxillerat Científic i Tecnològic
  */

const config =
{
    cid: 'a8020620',

    // llistat dels camps d'autorització del pas "Protecció de dades" d'aquest centre
    // (veure src/components/enrolmentform/authorizations/pompeufabra/)
    autoritzacions: [
        'authCompromis', 'authDretsImatge', 'authGDPR', 'authMedica', 'authPortatils',
        'authRecursosDigitals', 'authReligio', 'authResponsable', 'authSortides',
    ],

    phone: "937 755 916",
    email: "secretaria@iespompeufabra.cat",

    headerLogo:  'img/logo_bn_pompeufabra.png',
    headerTitle:  'Institut Pompeu Fabra',
    headerURL: 'https://matricula.iespompeufabra.cat/',

    //enrollmentPostURL: 'https://matricula.iespompeufabra.cat/post/',
    enrollmentPostURL: '/post/',
    //apiURL: 'https://matricula.iespompeufabra.cat/api/',
    apiURL: '/api/',

    popupInicial: true,

    validaIDdocuments: true,
    tipusDocTSI: true,
    tipusDocPreInscripcio: false,

    // Pompeu Fabra NO ofereix pagament en 2 terminis (decisió confirmada, no un oblit): a
    // diferència de la resta de centres, aquí NO es declara dosTerminisEnabled a propòsit,
    // així que quotes.pompeufabra.js (que sí que el consulta) el troba sempre undefined/fals
    // i el checkbox "Vull fer el pagament en 2 terminis" no s'arriba a mostrar mai.

    // abans "noPreguntarDadesLaborals: true": apartats a ometre per defecte quan el DNI no té curs obligatori
    apartatsOmesosPerDefecte: ['laborals'],

    /* PF: CAS ESPECIAL PER CONTINUITAT

    Abans es controlava manualment amb una "fase de continuïtat" per a tot el centre.
    Ara es determina per DNI+curs (veure curs.adjuntarArxiusNoObligatori / curs.noPreguntarSiEsNouAlumne
    a les dades de families); aquests valors només s'apliquen a la matrícula lliure (sense curs obligatori).
    */
    adjuntarArxiusNoObligatori: false,

    // llibre de família (plana progenitors + plana alumne) obligatori per als menors d'edat
    llibreFamiliaObligatori: true,
    noPreguntarSiEsNouAlumne: false,

    fotoCarnet: false,
    validaIAfotoCarnetFile: false,
    validaIAiddocumentFrontFile: false,

    telefonObligatori: false,
    carnetFamiliaNombrosa: false,

    contacteEmergenciaObligatori: true,

    adjuntMedic: true,
    adjuntMedicObligatori: false,

    datesNoBloquejenInscripcio: false,


    //proporcionarPreinscripcioNous: true,
    //proporcionarTitolPreinscripcioNous: true,

    notesAcces: true,

    mostraTorns: false,

    autoritzacioReligioAbansTriarAssignatures: true,

    logo: 'img/logo_pompeufabra.jpg',
    titol: 'IES Pompeu Fabra',

    favicon: '/img/favicon-pompeufabra.ico',
    faviconGestio: '/gestio/img/favicon-pompeufabra.ico',

    assignatures: 'assignatures/assignatures.pompeufabra.json',
    families: 'families/families.pompeufabra.json',
    dadesbancaries: 'dadesbancaries/dadesbancaries.pompeufabra.json',
    calculquota: 'quotes.pompeufabra.json',

    textNESEB: " <h3>MOTXILLA ESCOLAR</h3> El teu fill/a ha rebut l’ajut de la Motxilla Escolar. L’objecte d’aquest ajut és l'assignació de recursos econòmics als centres, que tenen matriculat per al curs 2025-2026 alumnat NESE B.Generalitat de Catalunya​ Departament d’Educació ​ i Formació Professional Institut Pompeu Fabra.  <br/> Els imports que els centres rebran en relació amb le​s motxilles de l’alumnat d'ESO, en el cas dels centres públics van destinats a: <ul> <li>Quota de material escolar</li> <li>Sortides i colònies</li> <li>Llibres</li> </ul> <p>Per tant, no és necessari pagar la quota de material ni despeses derivades d’activitats pedagògiques del centre.</p>",

    /* camps especifics per centre */
    treballantFile: true,
    necessitatsEducativesEspecials: true,

    repetidor: false,
    repetidorsNoPodenAgafarAssignaturesDe2n: false,

    textDadesMediquesAlgunSi: "Sempre que sigui imprescindible administrar medicaments a l'alumnat en l'horari lectiu, caldrà prèviament que els pares, mares o tutors legals aportin la documentació següent:<ul><li>Un <b>informe mèdic</b> on consti el nom de l'alumne o alumna, el nom del medicament que ha de prendre i la pauta d'administració.</li> <li>Una <b>autorització</b> on se sol·liciti a la direcció del centre educatiu l'administració a l'alumne o alumna del medicament prescrit, d'acord amb les pautes que constin en l'informe esmentat anteriorment, i se n'autoritzi l'administració al personal del centre.</li></ul> ",




    textTriarAssignatures: {
      ESOLOE01:  `Les matèries Optatives són matèries que l’alumnat pot triar. Impliquen 2 hores a la setmana i duren un
        quadrimestre, serveixen per iniciar, reforçar o ampliar la resta de matèries que es fan.
        En el full de tria, l’alumnat fa l’elecció de la matèria Optativa que farà durant el primer quadrimestre. Al
        llarg del curs es farà la tria de les optatives i projectes del segon quadrimestre.
        L’oferta d’optatives pot sofrir modificacions per canvis a nivell d’organització. Aquestes modificacions seran
        comunicades als alumnes. De qualsevol manera, la tria de matèries Optatives serà revisada pels tutors/res i
        professors/es per tal que sigui correcta i coherent. Es podrà assignar una matèria optativa de forma
        automàtica a l’alumnat que no ha superat alguna CB de primària.
        <b>Cal que enumereu TOTES les optatives per ordre de preferència, posant l’1 a la matèria que més us
        interessa, un 2 a la següent i així successivament fins que totes les optatives i tots els projectes tinguin
        un número.</b>`,

      BATX:  `<div>Aquí trobareu la descripció detallada de matèries de cadascun de les modalitats de Batxillerats:
      <ul>
               <li><a href="/docs/Curriculum-1r-de-Batxillerat-segons-modalitat.xlsx" target="_blank" rel="noreferrer">Currículum de 1r de Batxillerat segons modalitat</a></li>
      </ul>

      L'acceptació d'una matèria optativa o una altra estarà supeditada al nombre de grups que es puguin crear i als criteris organitzatius interns del centre.
      </div>
      `

      },

    batxilleratNocturnText: "Heu de fer constar la vostra situació acadèmica. Les matèries pendents que pugueu tenir, les matèries que ja heu fet, si feu matèries soltes o flexibilització. Qualsevol informació rellevant per la vostra matrícula.",

    textReunioInformativa1rESO: "Us convoquem a la primera reunió informativa de l’alumnat de 1r d’ESO el proper <b>2 de juliol de 2026 a les 18h</b> al Centre Cultural de Martorell.",

    textInformacioLlibres1rESOBecats: "Us convoquem al centre el proper 25 de juny de 9:30h a 14h i de 15 a 17h per realitzar la comanda de llibres del vostre fill/a.",

    textInformacioLlibres1rESO: "Aquelles famílies que vulguin demanar o retornar els llibres presencialment, us convoquem el proper 25 de juny de 2026 de 9:30 h a 10:30h a la Biblioteca del centre. Fora d'aquestes dates podeu contactar amb Iddink per fer la comanda. El codi del nostre centre és: 211PF7",

    textBotoMatricular: "INSCRIURE",

    textAlumneNouAlCentre: "Ets alumne nou als estudis que et matricules?",
    textAlumneNouAlCentreSub: "Si has fet preinscripció pel curs 2026-2027, marca SÍ, per la resta de casos cal indicar NO. Si el curs 2025-2026 has estudiat en el nostre centre marca NO",

    urlTPV: "https://matricula.iespompeufabra.cat/tpv/",
    pagamentTPV: true,
    pagamentTransferencia: false,

    sexeNoBinari: false,

    pattern_batx_nocturn: /^BATXLOE\d{5}N[A-Z]{0,2}$/,
    pattern_1r_batx: /^BATXLOE\d{4}1[^N]?[A-Z]{0,2}$/,
    pattern_2n_batx: /^BATXLOE\d{4}2[^N]?[A-Z]{0,2}$/,

    su: ['WyIxMTExMTEx', 'MUgiLCIyMjIyMjIyM', 'koiLCI0NTQ5MjQwNVMiXQ=='],
  };

export default  config;
